export function getFormattedDate(dateTime: string) {
  const date = new Date(dateTime);

  if(date.toString() === 'Invalid Date') {
    return false;
  }

  const day = date.getDate().toString().padStart(2, '0');
  const month = date.getMonth().toString().padStart(2, '0');
  return day + '.' + month + '.' + date.getFullYear();
}
